import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import './CheckBoxInputStyles.scss';
import { Icons } from '../../base/BootstrapComponents';
import CheckBoxInput from './CheckBoxInput';

export default function CheckBoxAccordion(props) {
  const {
    children = null,
    className = '',
    label = '',
    clearFilter = () => {},
    setFilterValue = () => {},
    filter = {},
    keys = [],
  } = props;
  const [isOpen, setOpen] = useState(false);
  const blockRef = useRef(null);
  const id = `check-box-accordion-${Math.random() * 10000}`;
  const handleClickOutside = event => {
    if (blockRef && (!blockRef.current || !blockRef.current.contains(event.target))) {
      setOpen(false);
    }
  };

  const keyDown = event => {
    if (event.keyCode === 27 && isOpen) {
      setOpen(false);
      event.preventDefault();
      event.stopPropagation();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('keydown', keyDown);
    // window.customEventListener.addEventListener('scroll', handleScroll, id);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside.bind(this));
      window.removeEventListener('keydown', keyDown.bind(this));
      // window.customEventListener.removeEventListener('scroll', id);
    };
  });
  const isAll = keys.every(p => filter[p]);
  const isSome = keys.some(p => filter[p]) && !isAll;
  return (
    <div className={classNames('check-box-accordion', { open: isOpen }, className)} ref={blockRef}>
      <div className="cbl-accordion-label">
        <div className="cbl-checkbox bordered-checkbox">
          <CheckBoxInput
            className={classNames('cbl-group-checkbox', { 'some-child': isSome }, { 'every-child': isAll })}
            inputProps={{
              value: isAll,
              onChange: e => {
                if (isAll) {
                  clearFilter();
                } else {
                  for (let i = 0; i < keys.length; i++) {
                    setFilterValue(keys[i], true);
                  }
                }
              },
            }}
          />
        </div>
        <div className="accordion-label-text" onClick={() => { setOpen(!isOpen); }}>{label}</div>
        <div className="accordion-icons accordion-icons-arrow">
          <Icons customIcon className="check-box-accordion-icon" width={12} height={8} icon="expand-more" onClick={() => { setOpen(!isOpen); }} />
        </div>
      </div>
      <div className="check-box-accordion-content">
        {children}
      </div>
    </div>
  );
}
